// Centralized URL-flag gate for the OGS profiling surface. Read once and cached
// so the hot path pays a single boolean check.
//
//   ?perf=1  the GpuLifter timestamp-query + the timestamp-query device feature.

function flag(name: string): boolean {
  try {
    return (
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get(name) === "1"
    );
  } catch {
    return false;
  }
}

let _perf: boolean | undefined;

/** Master profiling switch (?perf=1). Gates GPU-timing collection. */
export function wantsProfiling(): boolean {
  return (_perf ??= flag("perf"));
}
